import src from "IMAGE";
export default { src, width: 426, height: 426, blurWidth: 0, blurHeight: 0};
